module.exports = __webpack_public_path__ + "img/rank_top_bg.07ceb79f.png";